import T from 'i18n-react';

export const getFullAddress = ({
  region,
  city,
  cityKana,
  streetAddress,
  building,
  withKana = false,
} = {}) => {
  return [
    region,
    city,
    withKana && cityKana ? T.translate('parentheses', { text: cityKana }) : '',
    streetAddress,
    building,
  ]
    .filter((d) => d)
    .join('');
};
